module.exports = __webpack_public_path__ + "img/yizhongzhi@2x.c54159a8.png";